import React from 'react'
import { AiOutlineCheckCircle } from 'react-icons/ai'

const SenhaAlteradaSucesso = () => {
    return (
        <div className="div-form-login" style={{ maxWidth: '350px', margin: '0 auto' }}>
            <div className="div-wrapper-centralizado" style={{ padding: '20px' }}>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <AiOutlineCheckCircle size={80} color="#28a745" />
                </div>
                <h2 style={{ textAlign: 'center', color: 'white', marginBottom: '20px', fontSize: '1.8rem' }}>
                    Senha Alterada!
                </h2>
                <p className='texto-explicativo-superior' style={{ textAlign: 'center', fontSize: '1.1rem', lineHeight: '1.5' }}>
                    Sua nova senha foi cadastrada com sucesso.
                </p>
                <p className='texto-explicativo-superior' style={{ textAlign: 'center', marginTop: '15px', fontSize: '1rem', opacity: '0.9' }}>
                    Você já pode fechar esta aba e entrar no aplicativo com seus novos dados.
                </p>
            </div>
        </div>
    )
}

export default SenhaAlteradaSucesso
